import { useState, useEffect } from 'react';
import { NSInput, NSLabel } from 'bricks';

export interface CoordinateInputRowProps {
    name: 'latitude' | 'longitude';
    label: string;
    value: number | null;
    min: number;
    max: number;
    onCommit: (value: number | null) => void;
    labelClassName?: string;
    rowClassName?: string;
}

const CoordinateInputRow = ({
    name,
    label,
    value,
    min,
    max,
    onCommit,
    labelClassName,
    rowClassName,
}: CoordinateInputRowProps) => {
    const [inputValue, setInputValue] = useState<string>(value == null ? '' : String(value));
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (!isFocused) {
            setInputValue(value == null ? '' : String(value));
        }
    }, [value, isFocused]);

    const handleBlur = () => {
        setIsFocused(false);
        const trimmed = inputValue.trim();
        if (trimmed === '') {
            if (value !== null) {
                onCommit(null);
            }
            return;
        }
        const parsed = Number(trimmed);
        if (!Number.isFinite(parsed)) {
            return;
        }
        if (parsed !== value) {
            onCommit(parsed);
        }
    };

    const handleKeyDown = (event: { key: string; currentTarget: HTMLInputElement }) => {
        if (event.key === 'Enter') {
            event.currentTarget.blur();
        }
    };

    return (
        <div className={rowClassName}>
            <NSLabel className={labelClassName}>{label}</NSLabel>
            <NSInput
                type="number"
                name={name}
                value={inputValue}
                onChange={(e: { target: { value: string } }) => setInputValue(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                min={min}
                max={max}
                placeholder={`Enter ${label.toLowerCase()}`}
            />
        </div>
    );
};

export default CoordinateInputRow;
